import { useQuery } from "@tanstack/react-query";

export function useUnreadNotificationCount() {
  const { data: countData } = useQuery<{ count: number }>({
    queryKey: ["/api/notifications/unread-count"],
    queryFn: async () => ({ count: 0 }),
    refetchInterval: 30000,
  });
  return countData?.count || 0;
}
